// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cBw8nO_RjM7vmY5s {
  padding: 48px 0;
  display: flex;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./app/assets/components/NoPermission/index.modules.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AACF","sourcesContent":[".container {\n  padding: 48px 0;\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `cBw8nO_RjM7vmY5s`
};
export default ___CSS_LOADER_EXPORT___;
